import type { InvoiceState, LineItem } from "../types/billing";

export const emptyInvoice: InvoiceState = {
  lineItems: [],
  customer: null,
  lane: null,
  totalQty: 0,
  totalValue: 0,
  discount: 0,
  totalGrossAmount: 0,
  totalTaxAmount: 0,
  totalCessAmount: 0,
  totalAdditionalCessAmount: 0,
  extraDiscountPercent: 0,
  extraDiscountAmount: 0,
  roundoff: 0,
  splitEligible: false,
  splitEnabled: false,
};

export function computeTotals(
  lineItems: LineItem[],
  extraDiscountPercent: number,
  roundoff: number,
): {
  totalQty: number;
  totalValue: number;
  discount: number;
  totalGrossAmount: number;
  totalTaxAmount: number;
  totalCessAmount: number;
  totalAdditionalCessAmount: number;
  extraDiscountAmount: number;
} {
  let totalQty = 0;
  let netAmount = 0;
  let eligibleDiscountAmount = 0;
  let discount = 0;
  let totalGrossAmount = 0;
  let totalTaxAmount = 0;
  let totalCessAmount = 0;
  let totalAdditionalCessAmount = 0;
  let extraDiscountAmount = 0;
  for (const item of lineItems) {
    totalQty += item.quantity;
    netAmount += item.netAmount;
    if (item.discountFlag === "Y") {
      eligibleDiscountAmount += item.discountAmount;
    }
    discount += item.showDiscount;
    totalGrossAmount += item.grossAmount;
    totalTaxAmount += item.taxAmount;
    totalCessAmount += item.cessAmount;
    totalAdditionalCessAmount += item.additionalCessAmount;
    if (extraDiscountPercent > 0) {
      extraDiscountAmount +=
        (item.price * item.quantity * extraDiscountPercent) / 100;
    }
  }
  const totalValue =
    Math.round(netAmount - eligibleDiscountAmount) -
    Math.round(extraDiscountAmount) -
    roundoff;
  return {
    totalQty,
    totalValue,
    discount,
    totalGrossAmount,
    totalTaxAmount,
    totalCessAmount,
    totalAdditionalCessAmount,
    extraDiscountAmount,
  };
}

export function updateInvoiceItems(
  invoice: InvoiceState,
  lineItems: LineItem[],
): InvoiceState {
  const totals = computeTotals(
    lineItems,
    invoice.extraDiscountPercent,
    invoice.roundoff,
  );
  return { ...invoice, lineItems, ...totals };
}
